function transformDate(date) {
  if (!date) return date;
  const dateParts = date.split('/');
  if (dateParts.length !== 3) return date;
  return dateParts.reverse().join('-');
}

function cleanMontant(montant) {
  if (montant == null) return montant;
  return montant.toString().replace(/\s/g, '');
}


export function transformToGescomAchat(payload) {
  const query = {
    code: payload.query.code,
    montantHt: cleanMontant(payload.query.montant),
    client: payload.query.pointDeVente,
    societeId: payload.query.societeId,
    dateCreation: transformDate(payload.query.dateCreation),
    hasReferenceHavas: payload.query.hasReferenceHavas,
    
    sens: payload.query.sens,
    module: payload.query.module,
    etat: payload.query.etat,
    sousType: payload.query.sousType,
    typeReferenceExterne: payload.query.typeReferenceExterne,
    referenceExterne: payload.query.referenceExterne,
    referenceHavas: payload.query.referenceHavas,
  };
  
  const orderTranslate = {
    dateCreation: "CreationTime",
    montant: "MontantHt",
    code: "Code",
    etat: "Etat",
  };
  
  if (orderTranslate[payload.orderBy]) {
    payload.orderBy = orderTranslate[payload.orderBy];
  }
  
  Object.keys(query).forEach(key => {
    if (query[key] === null || query[key] === undefined) {
      delete query[key];
    }
  });
  
  return {
    ...payload,
    query,
  };
}

export function getFournisseurFromDevis(devis) {
  if (!devis.intervenants || devis.intervenants.length === 0) return '';
  const fournisseur = devis.intervenants.find(i => i.donneurOrdre);
  return fournisseur && fournisseur.nomCommercial ? fournisseur.nomCommercial : '';
}

export function getReferenceHavasFromDevis(devis) {
  return devis.referenceHavasSpotWeb || devis.referenceHavasSpotGestion || devis.orderNumeroHavas || '';
}